<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-row
      align="baseline"
      justify="center"
      class="ma-0"
    >
      <v-col
        cols="12"
        sm="12"
        md="5"
        lg="5"
        xl="5"
        class="py-md-0 py-lg-0 py-xl-0"
      >
        <v-text-field
          id="filter-processing-name"
          label="Nome do processamento"
          outlined
          rounded
          dense
          hide-details
          v-model="nmFilterLocal"
          :disabled="this.disabled"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="5"
        lg="5"
        xl="5"
        class="py-md-0 py-lg-0 py-xl-0"
      >
        <v-select
          id="filter-processing-status"
          label="Status do processamento"
          outlined
          rounded
          dense
          multiple
          append-icon="mdi-plus"
          clearable
          small-chips
          deletable-chips
          hide-details
          :items="statusList"
          v-model="statusFilterLocal"
          :disabled="this.disabled"
        >
          <template v-slot:prepend-item>
            <v-list-item
              ripple
              @click="toggleStatus"
            >
              <v-list-item-action>
                <v-icon :color="statusFilterLocal.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Todos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"/>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 2">
              <span>{{ item.text }}</span>
            </v-chip>
            <span
              v-if="index === 2"
              class="grey--text caption"
            >(+{{ statusFilterLocal.length - 2 }} outros)</span>
          </template>
        </v-select>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="2"
        lg="2"
        xl="2"
        class="py-md-0 py-lg-0 py-xl-0"
      >
        <v-row
          id="filter-order-processings"
          align="start"
          justify="start"
          justify-md="start"
          justify-sm="start"
          justify-lg="start"
          justify-xl="start"
          class="ma-0"
        >
          <!-- <v-menu offset-y :disabled="this.disabled">
            <template v-slot:activator="{ on: menu }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    v-on="{...menu, ...tooltip}"
                  >
                    <v-icon color="accent">mdi-sort-alphabetical-variant</v-icon>
                  </v-btn>
                </template>
                <span>Ordenar por nome</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item
                @click="onOrderByNameAscClick"
              >
                <v-list-item-icon>
                  <v-icon>mdi-sort-alphabetical-ascending</v-icon>
                </v-list-item-icon>
                <v-list-item-title>A - Z</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="onOrderByNameDescClick"
              >
                <v-list-item-icon>
                  <v-icon>mdi-sort-alphabetical-descending</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Z - A</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
          <v-menu offset-y :disabled="this.disabled">
            <template v-slot:activator="{ on: menu }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    v-on="{...menu, ...tooltip}"
                  >
                    <v-icon color="accent">mdi-calendar-range</v-icon>
                  </v-btn>
                </template>
                <span>Ordenar por data</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item
                @click="onOrderByDateDescClick"
              >
                <v-list-item-icon>
                  <v-icon>mdi-sort-descending</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Mais recentes</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="onOrderByDateAscClick"
              >
                <v-list-item-icon>
                  <v-icon>mdi-sort-ascending</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Mais antigos</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <v-menu offset-y :disabled="false">
            <template v-slot:activator="{ on: menu }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    v-on="{...menu, ...tooltip}"
                  >
                    <v-icon color="accent" v-text="$vuetify.icons.values['mdiFormatListNumbered']"/>
                  </v-btn>
                </template>
                <span>Processamentos por página</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item v-for="value in processingPerPageOptions" :key="value"
                @click="() => {onProcessingPerPageClick(value)}"
              >
                {{ value }}
              </v-list-item>
            </v-list>
          </v-menu> -->

          <!-- <v-menu offset-y :disabled="false">
            <template v-slot:activator="{ on: menu }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    v-on="{...menu, ...tooltip}"
                  >
                    <v-icon color="accent" v-text="$vuetify.icons.values['mdiBookOpenPageVariant']"/>
                  </v-btn>
                </template>
                <span>Pastas por página</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item v-for="value in projectPerPageOptions" :key="value"
                @click="() => {onProjectPerPageClick(value)}"
              >
                {{ value }}
              </v-list-item>
            </v-list>
          </v-menu>           -->
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {PROCESSING_STATUS_FILTER_LIST} from "../../helpers/processings/constants"
  import {map} from "lodash/collection"

  export default {
    name: "ProcessingListFilter",
    props: {
      nameFilter: String,
      statusFilter: Array,
      processingPerPage: Number,
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    data: () => ({
      nmFilterLocal: null,
      statusFilterLocal: [],
    }),
    methods: {
      toggleStatus() {
        this.$nextTick(() => {
          if (this.selectedAllStatus) {
            this.statusFilterLocal = []
          } else {
            this.statusFilterLocal = map(this.statusList, obj => obj.value)
          }
        })
      },
      onOrderByNameAscClick() {
        this.$emit("order-by-name", "asc")
      },
      onOrderByNameDescClick() {
        this.$emit("order-by-name", "desc")
      },
      onOrderByDateAscClick() {
        this.$emit("order-by-date", "asc")
      },
      onOrderByDateDescClick() {
        this.$emit("order-by-date", "desc")
      },
      onProcessingPerPageClick(value) {
        this.$emit("update:processing-per-page", value)
      },
      onProjectPerPageClick(value) {
        this.$emit("update:project-per-page", value)
      },      
    },
    computed: {
      statusList() {
        return PROCESSING_STATUS_FILTER_LIST
      },
      selectedAllStatus() {
        return this.statusFilterLocal.length === this.statusList.length
      },
      selectedSomeStatus() {
        return this.statusFilterLocal.length > 0 && !this.selectedAllStatus
      },
      icon() {
        if (this.selectedAllStatus) return "mdi-close-box"
        if (this.selectedSomeStatus) return "mdi-minus-box"
        return "mdi-checkbox-blank-outline"
      },
      processingPerPageOptions() {
        return [4, 8, 12]
      },
      projectPerPageOptions() {
        return [4, 8, 12, 24, 48]
      }      
    },
    watch: {
      nmFilterLocal(newValue) {
        this.$emit("update:nameFilter", newValue)
      },
      statusFilterLocal(newValue) {
        this.$emit("update:statusFilter", newValue)
      },
    },
  }
</script>

<style scoped lang="scss">
  @import "src/sass/mixins";

  .v-btn {
    @include display-lg-and-down {
      margin: 5px;
    }
  }
</style>
